module.exports = __webpack_public_path__ + "img/ayudaSolidaria.f848e9fa.jpg";